/** Grid Lines. */
export enum GridLines {
  Center = 'center',
  None = 'none',
  Thirds = 'thirds'
}

/** Control Tool. */
export enum Tool {
  Center = 'center',
  FastFrame = 'fast-frame',
  Joystick = 'joystick',
  Tracking = 'tracking',
  Zoom = 'zoom'
}
